import { useEffect, useState } from 'react'
import styled from 'styled-components'
import Mission from './Mission/Mission'
import Partnership from './Partnership/Partnership'
import Popup from './Popup/Popup'
import SliderMain from './SliderMain/SliderMain'

import SliderNews from './SliderNews/SliderNews'
import SliderPatent from './SliderPatent/SliderPatent'
import SliderProduct from './SliderProduct/SliderProduct'
import SliderTechnology from './SliderTechnology/SliderTechnology'

function Main() {
  const [showPopup, setShowPopup] = useState(
    () => !sessionStorage.getItem('popupShown')
  )

  useEffect(() => {
    sessionStorage.setItem('popupShown', 'true')
  }, [])

  const handleClose = () => {
    setShowPopup(false)
  }

  return (
    <Container>
      {showPopup && <Popup onClose={handleClose} />}
      <SliderMain />
      <Mission />
      <SliderTechnology />
      <SliderProduct />
      <SliderNews />
      <SliderPatent />
      <Partnership />
      {/* <SliderMembers /> */}
    </Container>
  )
}

export default Main

// styled-components

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
`
